import { sva } from "@agapi/ui/panda/css";

export const alertBannerStyles = sva({
  slots: ['root', 'item', 'label', 'clickable', 'linkButton'],
  base: {
    root: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      md: {
        flexDirection: 'row'
      },
      sm: {
        fontSize: '1rem'
      }
    },
    item: {
      display: 'flex',
      alignItems: 'center',
      flex: 1,
      py: '2',
      textAlign: 'center',
      px: 'app',
    },
    label: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '2',
      width: '100%',
      textAlign: 'center'
    },
    clickable: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flex: 1,
      cursor: 'pointer',
      transition: 'opacity 0.2s ease',
      background: 'transparent',
      border: 'none',
      color: 'inherit',
      textDecoration: 'none',
      '&:hover': {
        opacity: 0.9
      }
    },
    linkButton: {
      flexShrink: 0,
      color: 'inherit',
      textDecoration: 'underline',
      padding: '4px 8px',
      borderRadius: 'xs',
      background: 'transparent',
      border: 'none',
      cursor: 'pointer'
    }
  }
});
